import { kv } from '@vercel/kv';

const isProduction = process.env.NODE_ENV === 'production';

export const storage = {
  async getUser(email) {
    if (isProduction) {
      try {
        return await kv.get(`user:${email}`);
      } catch (error) {
        console.error('KV get user error:', error);
        return null;
      }
    }
    const users = JSON.parse(localStorage.getItem('users') || '{}');
    return users[email] || null;
  },

  async setUser(email, userData) {
    if (isProduction) {
      try {
        await kv.set(`user:${email}`, userData);
        // Also track in users list
        const usersList = await kv.get('users:list') || [];
        if (!usersList.includes(email)) {
          usersList.push(email);
          await kv.set('users:list', usersList);
        }
      } catch (error) {
        console.error('KV set user error:', error);
      }
    } else {
      const users = JSON.parse(localStorage.getItem('users') || '{}');
      users[email] = userData;
      localStorage.setItem('users', JSON.stringify(users));
    }
  },

  async getCurrentUser() {
    if (isProduction) {
      try {
        return await kv.get('currentUser');
      } catch (error) {
        console.error('KV get current user error:', error);
        return null;
      }
    }
    return localStorage.getItem('currentUser');
  },

  async setCurrentUser(email) {
    if (isProduction) {
      try {
        await kv.set('currentUser', email);
        // Track login
        await this.trackLogin(email);
      } catch (error) {
        console.error('KV set current user error:', error);
      }
    } else {
      localStorage.setItem('currentUser', email);
    }
  },

  async removeCurrentUser() {
    if (isProduction) {
      try {
        await kv.del('currentUser');
      } catch (error) {
        console.error('KV remove current user error:', error);
      }
    } else {
      localStorage.removeItem('currentUser');
    }
  },

  async trackLogin(email) {
    if (isProduction) {
      try {
        const loginKey = `logins:${email}`;
        const logins = await kv.get(loginKey) || [];
        logins.push({
          timestamp: new Date().toISOString(),
          ip: 'unknown', // Could be enhanced with IP tracking
          userAgent: navigator.userAgent
        });
        await kv.set(loginKey, logins);
      } catch (error) {
        console.error('KV track login error:', error);
      }
    }
  },

  async addAssessment(email, assessment) {
    const user = await this.getUser(email);
    if (user) {
      user.assessments = user.assessments || [];
      user.assessments.push({
        ...assessment,
        id: Date.now().toString(),
        timestamp: new Date().toISOString()
      });
      user.lastActivity = new Date().toISOString();
      await this.setUser(email, user);
    }
  },

  async getAllUsers() {
    if (isProduction) {
      try {
        const usersList = await kv.get('users:list') || [];
        const users = {};
        for (const email of usersList) {
          const userData = await kv.get(`user:${email}`);
          if (userData) {
            users[email] = userData;
          }
        }
        return users;
      } catch (error) {
        console.error('KV get all users error:', error);
        return {};
      }
    }
    return JSON.parse(localStorage.getItem('users') || '{}');
  },

  async getUserLogins(email) {
    if (isProduction) {
      try {
        return await kv.get(`logins:${email}`) || [];
      } catch (error) {
        console.error('KV get user logins error:', error);
        return [];
      }
    }
    return [];
  }
};